/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
// @ts-expect-error ts-migrate(2741) FIXME: Property 'analytics' is missing in type '{ getJSON... Remove this comment to see the full error message
window.lsCloud = {
  getJSONFromAPI(path) {
    const deferred = $.Deferred();
    // readonly forces the connection to be made against the slave databases
    $.getJSON(path, { readonly: '1' })
      .done(data => deferred.resolve(data))
      .fail((jqXHR, textStatus, errorThrown) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleLogout' does not exist on type 'Wi... Remove this comment to see the full error message
        if (typeof window.handleLogout === 'function') {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleLogout' does not exist on type 'Wi... Remove this comment to see the full error message
          $.when(window.handleLogout())
            .done(data => {
              if (path === '/API/Session') {
                deferred.resolve(data);
                return;
              }
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'getJSONFromAPI' does not exist on type '... Remove this comment to see the full error message
              $.when(window.getJSONFromAPI(path)) // after login try again
                .done(data => deferred.resolve(data))
                .fail((jqXHR, textStatus, errorThrown) =>
                  deferred.reject(jqXHR, textStatus, errorThrown)
                );
            })
            .fail((jqXHR, textStatus, errorThrown) =>
              deferred.reject(jqXHR, textStatus, errorThrown)
            );
        } else {
          deferred.reject(jqXHR, textStatus, errorThrown);
        }
      });
    return deferred.promise();
  },

  startServerJob(job, silent_fail) {
    const deferred = $.Deferred();
    const json = JSON.stringify(job.obj);
    const type = 'PUT';

    const obj: LSCloudServerJob = {
      type,
      url: job.url,
      data: job.data,
    };

    if (job.type) {
      obj.type = job.type;
    }

    // Handle json data differently than xml data
    if (json) {
      obj.data = json;
      obj.contentType = 'application/json; charset=utf-8';
      obj.dataType = 'json';
    }

    $.ajax(obj)
      .done((data, _textStatus, jqXHR) => {
        deferred.resolve(data);
        return jqXHR;
      })
      .fail((jqXHR, _textStatus, errorThrown) => {
        window.merchantos.error(jqXHR, errorThrown);

        if (silent_fail) {
          deferred.resolve(errorThrown);
          return;
        }
        const e = jqXHR;
        if (e.status !== 401) {
          let errorMessage = 'Please Try Again';
          try {
            errorMessage = JSON.parse(e.responseText).failed_msg || errorMessage;
            // eslint-disable-next-line no-empty
          } catch (error) {}

          window.alertUser(`Couldn't save (${errorMessage})`);
          deferred.reject(e);
          return;
        }
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleLogout' does not exist on type 'Wi... Remove this comment to see the full error message
        if (typeof window.handleLogout === 'function') {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleLogout' does not exist on type 'Wi... Remove this comment to see the full error message
          $.when(window.handleLogout())
            .done(data => {
              // TODO: is this dead code? or is this meant to be window.location.path
              // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'path'.
              if (path === '/API/Session') {
                deferred.resolve(data);
                return;
              }
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'getJSONFromAPI' does not exist on type '... Remove this comment to see the full error message
              $.when(window.getJSONFromAPI(path)) // after login try again
                .done(data => deferred.resolve(data))
                .fail(() => deferred.reject());
            })
            .fail(() => deferred.reject());
        } else {
          deferred.reject(e);
        }
      });

    return deferred;
  },

  Config: {
    __config: {},
    __loaded: false,

    __load() {
      const deferred = $.Deferred();
      if (this.__loaded) {
        deferred.resolve(this.__config);
      } else if (window.merchantos.session.getSystemCustomerID()) {
        window.lsCloud
          .getJSONFromAPI(`/API/Account/${window.merchantos.session.getSystemCustomerID()}/Config`)
          .done(configs => {
            window.lsCloud.Config.__loaded = true;

            configs.Config.forEach(
              // eslint-disable-next-line no-return-assign
              (config: TSFixMe) => (window.lsCloud.Config.__config[config.name] = config.value)
            );

            deferred.resolve(window.lsCloud.Config.__config);
          })
          .fail(() => deferred.reject());
      } else {
        deferred.reject();
      }
      return deferred;
    },

    access(name) {
      const deferred = $.Deferred();
      if (this.__config[name]) {
        deferred.resolve(this.__config[name]);
      } else {
        this.__load().always(() => {
          if (name) {
            deferred.resolve(window.lsCloud.Config.__config[name]);
          } else {
            deferred.resolve(window.lsCloud.Config.__loaded);
          }
        });
      }
      return deferred;
    },

    set(name, value) {
      this.__config[name] = value;
    },
  },

  Modules: {
    waitForModules: $.Deferred(),
    /** Module cache */
    __modules: {},

    /**
     * Stores all customer modules.
     * @param {Object} modules
     */
    setModules(modules) {
      if (typeof modules !== 'object') {
        window.merchantos.error('Tried to use non-object for Modules.');
      } else {
        const module_cache = this.__modules;
        // Delete old module entries
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        Object.keys(module_cache).forEach(key => delete module_cache[key]);
        // Set new modules
        Object.keys(modules).forEach(key => {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          module_cache[key] = modules[key];
        });
        this.waitForModules.resolve();
      }
    },

    /**
     * Returns true or false if the account has this module or not.
     * @param {String} module_name
     * @returns {boolean}
     */
    hasModule(module_name) {
      return !!this.__modules[module_name];
    },
  },

  Options: {
    __options: null,
    __loaded: false,

    __load(options) {
      // eslint-disable-next-line no-param-reassign
      options = options || { reload: false };
      const deferred = $.Deferred();
      if (window.lsCloud.Options.__options && options.reload === false) {
        deferred.resolve(window.lsCloud.Options.__options);
      } else {
        const id =
          window.merchantos.session.getSystemCustomerID() ||
          (window.merchantos.account && window.merchantos.account.id);
        window.lsCloud
          .getJSONFromAPI(`/API/Account/${id}/Option`)
          .done(opts => {
            window.lsCloud.Options.__options = opts.Option;
            deferred.resolve(window.lsCloud.Options.__options);
          })
          .fail(() => deferred.reject());
      }
      return deferred;
    },

    get(opt_names, options) {
      const deferred = $.Deferred();
      const isMultipleOptionNames = Array.isArray(opt_names);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ [key: string]: any; reload: bo... Remove this comment to see the full error message
      window.lsCloud.Options.__load(options)
        .done(options => {
          if (!isMultipleOptionNames) {
            // eslint-disable-next-line no-param-reassign
            opt_names = [opt_names as string];
          }
          const values: TSFixMe = [];
          (opt_names as string[]).forEach(opt_name =>
            options.forEach((option: TSFixMe) => {
              if (option.name === opt_name) {
                values.push(option.value);
                false;
              }
            })
          );
          deferred.resolve(isMultipleOptionNames ? values : values[0]);
        })
        .fail(() => deferred.reject());
      return deferred;
    },

    save(opt_name, opt_value) {
      if (window.lsCloud.Options.__options) {
        window.lsCloud.Options.__options.forEach((option: TSFixMe, index: TSFixMe) => {
          if (option.name === opt_name) {
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            window.lsCloud.Options.__options[index].value = opt_value;
            return false;
          }
          return true;
        });
      }
      return $.ajax({
        type: 'PUT',
        url: `/API/Account/${window.merchantos.session.getSystemCustomerID()}/Option`,
        data: `<Options><Option><name>${opt_name}</name><value>${opt_value}</value></Option></Options>`,
      });
    },
  },

  UserPreferences: {
    __preferences: null,
    __loaded: false,

    __load() {
      const deferred = $.Deferred();
      if (this.__preferences) {
        deferred.resolve(this.__preferences);
      } else {
        const custID = window.merchantos.session.getSystemCustomerID();

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        const employeeID = window.merchantos.session.getEmployee().employeeID;

        window.lsCloud
          .getJSONFromAPI(`/API/Account/${custID}/UserPreference?employeeID=${employeeID}`)
          .done(prefs => {
            window.lsCloud.UserPreferences.__preferences = prefs.UserPreference;
            deferred.resolve(window.lsCloud.UserPreferences.__preferences);
          })
          .fail(() => deferred.reject());
      }
      return deferred;
    },

    get(pref_name, component) {
      const deferred = $.Deferred();
      this.__load()
        .done(preferences => {
          let value = null;

          // Check to make sure the user has any preferences
          if (preferences) {
            if (!Array.isArray(preferences)) {
              // eslint-disable-next-line no-param-reassign
              preferences = [preferences];
            }
            preferences.forEach((pref: TSFixMe) => {
              if (pref.name === pref_name && (!component || pref.component === component)) {
                value = pref.value;
                return false;
              }
              return true;
            });
          }
          deferred.resolve(value);
        })
        .fail(() => deferred.reject());
      return deferred;
    },

    save(pref_name, pref_value, type, component) {
      const deferred = $.Deferred();
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const employeeID = window.merchantos.session.getEmployee().employeeID;
      let prefID: TSFixMe = null;
      let id = '';

      if (this.__preferences) {
        this.__preferences.forEach((pref: TSFixMe, index: TSFixMe) => {
          if (pref.name === pref_name) {
            window.lsCloud.UserPreferences.__preferences[index].value = pref_value;
            prefID = pref.userPreferenceID;
            return false;
          }
          return true;
        });
      }

      if (!component) {
        // eslint-disable-next-line no-param-reassign
        component = '';
      }

      if (!type) {
        // eslint-disable-next-line no-param-reassign
        type = '';
      }

      if (!prefID) {
        // eslint-disable-next-line no-param-reassign
        type = 'POST';
      } else {
        // eslint-disable-next-line no-param-reassign
        type = 'PUT';
        id = `/${prefID}`;
      }

      let data = `<UserPreference><employeeID>${employeeID}</employeeID>`;
      data += `<type>${type}</type>`;
      data += `<component>${component}</component>`;
      data += `<name>${pref_name}</name>`;
      data += `<value>${pref_value}</value></UserPreference>`;

      $.ajax({
        type,
        url: `/API/Account/${window.merchantos.session.getSystemCustomerID()}/UserPreference${id}`,
        data,
      })
        .done(preference => {
          if (!prefID) {
            window.lsCloud.UserPreferences.__preferences.push(preference.UserPreference);
          }
          deferred.resolve(preference);
        })
        .fail(() => deferred.reject());

      return deferred;
    },
  },

  Shops: {
    __shops: null,
    __loaded: false,

    __load() {
      const deferred = $.Deferred();
      if (this.__loaded) {
        deferred.resolve(this.__shops);
      } else {
        window.lsCloud
          .getJSONFromAPI(`/API/Account/${window.merchantos.session.getSystemCustomerID()}/Shop`)
          .done(shops => {
            if (!Array.isArray(shops.Shop)) {
              // eslint-disable-next-line no-param-reassign
              shops.Shop = [shops.Shop];
            }
            this.__loaded = true;
            window.lsCloud.Shops.__shops = shops.Shop;
            deferred.resolve(window.lsCloud.Shops.__shops);
          })
          .fail(() => deferred.reject());
      }
      return deferred;
    },

    get() {
      const deferred = $.Deferred();
      this.__load()
        .done(() => deferred.resolve(window.lsCloud.Shops.__shops))
        .fail(() => deferred.reject());
      return deferred;
    },
  },
};
